function RequiredIndicator() {
    return (
        <span className="text-destructive" aria-hidden="true">
            *
        </span>
    );
}

export default RequiredIndicator;
